/**
 * KB-2748 review round 3 — the pure TS port of the `.cjs` predicate that lives at
 * `scripts/camp-data/_shared/nonPageEndpointUrl.cjs` (vendored byte-identically to
 * `functions/scripts/camp-data/_shared/nonPageEndpointUrl.cjs`). This THIRD copy exists because
 * `evidence.pageUrl` (the same underlying value the pipeline guards) also seeds a CLIENT-side admin
 * form draft — `src/components/admin/camp/camp-data/reviewAccept/locationDraft.ts`'s
 * `authorLocationDraft`, via the `@/functions-shared` Vite alias into this file — where the pipeline's
 * `.cjs` module format cannot be imported directly (mirrors `regUrlValidation.ts`'s own reason for
 * existing as a TS port of the `.cjs` regUrl validators).
 *
 * Behavior is byte-for-byte faithful to the `.cjs` source: same two shape checks (`.json` API
 * payload, jackrabbit's OpeningsJS script endpoint), same `\b` (not `$`) boundary on the OpeningsJS
 * pattern (KB-2748 review round 1, finding 3 — a trailing-slash URL variant is real). If either
 * source changes shape, change all three; there is no automated lockstep guard across this specific
 * trio yet (unlike `regUrlValidation.ts`'s fixture-shared pair) — noted as a gap, not fixed here.
 */

/**
 * @returns the name of the matched bad shape ("json-api", "jackrabbit-openingsjs"), or "" when
 *   `url` is not a known machine-endpoint shape (including empty/malformed input).
 */
export function classifyNonPageEndpointShape(url: string | null | undefined): string {
  const s = String(url == null ? "" : url).trim();
  if (!s) return "";
  let u: URL;
  try {
    u = new URL(s);
  } catch {
    return "";
  }
  if (/\.json$/i.test(u.pathname)) return "json-api";
  if (/\/Openings\/OpeningsJS\b/i.test(u.pathname)) return "jackrabbit-openingsjs";
  return "";
}

/**
 * @returns true when `url` is a machine response endpoint (JSON API payload, or a script meant to
 *   be executed rather than read), never a page fit to store as an informational link.
 */
export function isNonPageEndpointUrl(url: string | null | undefined): boolean {
  return classifyNonPageEndpointShape(url) !== "";
}
